module.exports = __webpack_public_path__ + "img/img_tutorial_07.be5a1f42.svg";